import React from 'react';
import {
  TextCustom,
  TextAppearance,
  TextWeight,
  TextColor,
} from '@vw-marketing/us-components';
import { formatModifiedDate } from '../../../utils/general';
import { InputLabelContainer, DateWrapper } from './styled';

interface InputLabelProps {
  date?: string;
}
const InputLabel = ({ date }: InputLabelProps) => {
  return (
    <InputLabelContainer>
      <TextCustom
        appearance={TextAppearance.headline200}
        style={{ fontWeight: TextWeight.bold }}
      >
        VIN (Vehicle Identification Number)
      </TextCustom>
      <DateWrapper>
        <TextCustom
          appearance={TextAppearance.headline200}
          style={{ fontWeight: TextWeight.light, color: TextColor.secondary }}
        >
          Last updated {formatModifiedDate(date || '')}
        </TextCustom>
      </DateWrapper>
    </InputLabelContainer>
  );
};

export default InputLabel;
